
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import EditForm from './EditForm';

function getSteps() {
    return ['Pick what to personalize', 'Select personalized content', 'Review & confirm'];
}

const styles = theme => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing.unit,
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    }
});

class Step3 extends React.Component {
    static propTypes = {
        classes: PropTypes.object,
    };

    render() {
        const { classes } = this.props;
        const steps = getSteps();

        return (
            <Grid container spacing={24}>
                <Grid item xs={12}>
                    <Card style={{ cursor: 'pointer' }}>
                        <CardContent>
                            <Typography variant="headline">
                                Enter personalized content for Hero component
                            </Typography>
                            <EditForm />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(Step3);


// WEBPACK FOOTER //
// ./src/components/personalization/Step3.js